import header from '../_modules/header/index.js'
import { handleRefsUs, REFS_US } from '@studybay/common-client-library/ref-handle'
import { revealLinksOnAction } from "../_modules/helpers";

function handler() {
    const loadTriggers = {
        searchForm: 'searchForm',
        pagination: 'pagination',
        subjectSelect: 'select',
        onlineCheckbox: 'onlineCheckbox',
        submitFastreg: 'submitFastreg',
    }

    const head = document.head
    const header = document.querySelector('h1')
    const isAuth = window.A24?.isAuth || false
    const isCustomer = window.A24?.isCustomer || false
    const searchForm = document.querySelector('[data-js="search-form"]')
    const searchButton = searchForm.querySelector('button')
    const onlineOnlyCheckbox = document.getElementById('online-only-checkbox')
    const authorsList = document.querySelector('[data-js="authors"]')
    const subjectAreaSelect = document.getElementById('subject-area-select')
    const subjectSelect = document.getElementById('subject-select')
    const subjectOptions = document.querySelectorAll('[data-subject-category]')
    const paginationBlock = document.querySelector('[data-js="pagination"]')
    const fastRegModal = document.querySelector('[data-js="fastreg-modal"]')
    const authorIdInput = document.getElementById('authorId')
    const fastregCancelElements = document.querySelectorAll('[data-js="fastreg-cancel"]')
    const fastregError = fastRegModal.querySelector('[data-js="fastreg-error"]')
    const fastregForm = fastRegModal.querySelector('form')
    const fastregEmailInput = fastRegModal.querySelector('[type="email"]')
    const fastregSubmit = fastRegModal.querySelector('form button')

    let selectedSubjectId = null
    let isLoadingAuthors = false

    const fetchAuthorsOptions = {
        page: window.A24.ratingDefaults.page,
        group: window.A24.ratingDefaults.group,
        category: window.A24.ratingDefaults.category,
        work_type: 0,
        online_only: window.A24.ratingDefaults.onlineOnly,
        favorites: window.A24.ratingDefaults.favorites,
        nick_name: window.A24.ratingDefaults.nickname,
    }

    const setMeta = options => {
        let element = options.element || document.createElement(options.tag)
        const attrs = options.attrs
        const content = options.content
        if (attrs) {
            for (let attr in attrs) element.setAttribute(attr, attrs[attr])
        }
        if (content) element.innerHTML = content
        head.append(element)
    }

    const removeMeta = (element) => element && element.remove();
    const setLoadTriggerDisabled = (element, disabled, busy) => {
        element.disabled = disabled
        element.setAttribute('tabindex', disabled ? -1 : 0)
        element.setAttribute('aria-busy', Boolean(disabled && busy))
    }
    const setLoadingAuthors = (loading, trigger) => {
        isLoadingAuthors = loading
        authorsList.classList[loading ? 'add' : 'remove']('loading')

        const searchButtonBusy = loading && trigger === loadTriggers.searchForm

        setLoadTriggerDisabled(searchButton, loading, searchButtonBusy)
        setLoadTriggerDisabled(subjectAreaSelect, loading)
        setLoadTriggerDisabled(subjectSelect, loading)
        setLoadTriggerDisabled(onlineOnlyCheckbox, loading)
        authorsList.setAttribute('aria-busy', loading)
    }

    const setLoadPage = page => fetchAuthorsOptions.page = page
    const resetAuthorsList = () => authorsList.innerHTML = ''
    const setNickname = nickname => fetchAuthorsOptions.nick_name = nickname
    const setSubjectArea = area => fetchAuthorsOptions.group = area
    const setSubject = subject => fetchAuthorsOptions.category = subject
    const setOnline = (bool) => fetchAuthorsOptions.online_only = Number(bool)

    const setAuthorCardListeners = (cardElement) => {
        const authorId = cardElement.getAttribute('data-author-id')
        const isNovice = cardElement.getAttribute('data-author-id') === "true"

        const openFastregModal = () => {
            fastRegModal.hidden = false
            document.body.style.overflow = 'hidden'
            authorIdInput.value = authorId
        }

        if (isNovice) return

        if (!isAuth) {
            const hireButton = cardElement.querySelector('[data-js="hire-expert"]')
            hireButton.addEventListener('click', openFastregModal)
        }

        const toggleStatButton = cardElement.querySelector('[data-js="toggle-stat"]')
        const hideStatButton = cardElement.querySelector('[data-js="hide-stat"]')
        const statBlockId = toggleStatButton.getAttribute('aria-controls')
        const statBlock = cardElement.querySelector(`#${statBlockId}`)

        const openStatistics = () => {
            statBlock.classList.add('expanded')
            toggleStatButton.setAttribute('aria-expanded', true)
        }

        const hideStatistics = () => {
            statBlock.classList.remove('expanded')
            toggleStatButton.setAttribute('aria-expanded', false)
        }

        toggleStatButton.addEventListener('click', () => {
            const isExpanded = toggleStatButton.getAttribute('aria-expanded') === "true"
            if (isExpanded) return hideStatistics()
            openStatistics()
        })

        hideStatButton.addEventListener('click', hideStatistics)
    }

    const initAuthorsCards = () => {
        const authors = document.querySelectorAll('[data-js="author"]')
        authors.forEach((author) => {
            setAuthorCardListeners(author)
            setRating(author)
        })
    }

    const setRating = (cardElement) => {
        const ratingElement = cardElement.querySelector('[data-rating]')
        const rating = ratingElement.getAttribute('data-rating')
        ratingElement.style.setProperty('--rating', `${rating / 5 * 100 + 2}%`)
    }

    const statisticsItemTemplate = (stat) => (`
        <li class="li author-statistics__item">
            <div class="author-statistics__root">
                <span class="author-statistics__field">${stat.name}</span>
                <div class="author-statistics__numbers">
                    <span class="author-statistics__total">${stat.countOrders}</span>
                    <span class="author-statistics__likes">👍 ${stat.positiveGrades}</span>
                    <span class="author-statistics__dislikes">👎 ${stat.negativeGrades}</span>
                </div>
            </div>
        </li>
    `)

    const authorCardTemplate = (props) => {

        const {
            profileUrl,
            avatar,
            isNoviceRating,
            category_text,
            type_text,
            nick_name,
            online,
            user_id,
            verified,
            stats,
            readableOnline,
            grade,
            isAIFree,
        } = props

        const parsedGrade = parseFloat(grade)

        const statisticItems = stats.reduce((str, stat) => str + statisticsItemTemplate(stat), '')

        let hireElement = ''
        if (!isAuth) {
            hireElement = `<button class="button author-info__hire" type="button" data-js="hire-expert">hire the expert</button>`
        } else if (isCustomer) {
            hireElement = `<a class="a a--cta author-info__hire" href="/order/createorder/?invite=${user_id}">hire the expert</a>`
        }

        return `
            <div class="author__general-info">
                <a tabindex="-1" aria-hidden="true" href="${profileUrl}" target="_blank" class="author__avatar">
                    <img width="40" height="40" src="${avatar}" alt="">
                </a>
                <div class="author-info">
                    <div class="author-info__top">
                        <div class="author-info__left">
                            <span><a class="a a--shy author-info__name" href="${profileUrl}" target="_blank">${nick_name}</a></span>
                            ${verified ? `
                                <div class="author-info__verification" tabindex="0">
                                    <div class="author-info__verification-popup" aria-hidden="true">
                                        This expert is verified by Studybay. Their educational level and phone number were confirmed, also they successfully passed an interview thus proved they meet our quality standards.
                                    </div>
                                    <svg focusable="false" width="16" height="16" viewbox="0 0 27 25" role="img">
                                        <title>This expert is verified by Studybay. Their educational level and phone number were confirmed, also they successfully passed an interview thus proved they meet our quality standards.</title>
                                        <path d="M 13.5 22.5 L 10.21 24.28 C 9.72 24.54 9.13 24.35 8.9 23.86 L 7.31 20.54 L 3.57 20.09 C 3.02 20.02 2.67 19.53 2.77 18.99 L 3.49 15.4 L 0.74 12.89 C 0.33 12.52 0.33 11.92 0.74 11.55 L 3.49 9.04 L 2.77 5.45 C 2.67 4.91 3.01 4.42 3.57 4.35 L 7.31 3.9 L 8.9 0.58 C 9.14 0.09 9.73 -0.1 10.21 0.16 L 13.5 1.94 L 16.79 0.16 C 17.28 -0.1 17.87 0.09 18.1 0.58 L 19.69 3.9 L 23.43 4.35 C 23.98 4.42 24.33 4.91 24.23 5.45 L 23.51 9.04 L 26.26 11.55 C 26.67 11.92 26.67 12.53 26.26 12.89 L 23.51 15.4 L 24.23 18.99 C 24.33 19.53 23.99 20.02 23.43 20.09 L 19.69 20.54 L 18.1 23.86 C 17.86 24.36 17.27 24.54 16.79 24.28 L 13.5 22.5 Z M 13.5 22.5"></path><path fill="#ffffff" fill-rule="evenodd" d="M 16.16 9.28 L 12.39 13.02 L 10.95 11.6 C 10.45 11.11 9.65 11.11 9.15 11.6 C 8.65 12.1 8.65 12.9 9.15 13.39 L 11.49 15.71 C 11.73 15.96 12.06 16.08 12.39 16.08 C 12.71 16.08 13.04 15.95 13.29 15.71 L 17.96 11.07 C 18.46 10.58 18.46 9.78 17.96 9.28 C 17.46 8.79 16.66 8.79 16.16 9.28 L 16.16 9.28 Z M 16.16 9.28"></path>
                                    </svg>
                                </div>
                                ` : ''
                            }
                            ${ isAIFree ? `
                                <span class="author-info__ai-badge">
                                    <img 
                                        src="/assets/images/robotIcon.png" 
                                        class="ai-badge-icon"
                                    />
                                    <p class="ai-badge-text">AI free</p>
                                </span>
                            ` : ''
                            }
                            <span class="author-info__status ${online ? 'is-online' : ''}">${online ? 'online' : readableOnline}</span>
                        </div>
                        <div class="author-info__rating">
                            ${parsedGrade >= 0 && !isNoviceRating ? `
                                <div class="rating-stars" data-rating="${grade}" aria-hidden="true"></div>
                                <button type="button" class="rating-value naked-button" data-js="toggle-stat" aria-expanded="false" aria-controls="stat-${user_id}">
                                    <span class="IH">Author's rating is ${grade}</span>
                                    <span aria-hidden="true" class="dashed-text ">${grade}</span>
                                </button>
                            ` : ``
                            }
                            ${isNoviceRating ? `
                                <div class="novice-author">
                                    <div class="novice-author__popup" aria-hidden="true">
                                        This expert hasn't completed enough projects to be rated yet.
                                    </div>
                                    <span aria-hidden="true">new expert</span>
                                    <span class="IH">This expert hasn't completed enough projects to be rated yet</span>
                                    <svg class="novice-author__question-mark" viewBox="0 0 98.27 98.27" xmlns="http://www.w3.org/2000/svg" role="presentation">
                                        <path fill="#fff" d="M49.135,0C21.998,0,0,21.999,0,49.135S21.998,98.27,49.135,98.27c27.136,0,49.134-21.999,49.134-49.135S76.27,0,49.135,0zM53.234,82.086c-1.539,1.521-3.684,2.293-6.369,2.293c-2.746,0-4.918-0.754-6.456-2.241c-1.545-1.495-2.328-3.604-2.328-6.269c0-2.754,0.769-4.887,2.284-6.336c1.51-1.44,3.696-2.172,6.5-2.172c2.714,0,4.861,0.746,6.386,2.219c1.528,1.479,2.304,3.596,2.304,6.289C55.555,78.472,54.773,80.564,53.234,82.086z M68.424,40.295c-1.572,2.511-4.566,5.354-8.9,8.45c-2.817,2.083-4.627,3.684-5.355,4.74c-0.686,0.995-1.034,2.346-1.034,4.014v1.98c0,0.828-0.672,1.5-1.5,1.5H41.045c-0.828,0-1.5-0.672-1.5-1.5v-2.621c0-3.041,0.663-5.732,1.972-8c1.296-2.244,3.665-4.638,7.043-7.116c3.135-2.239,5.209-4.06,6.183-5.422c0.923-1.297,1.392-2.768,1.392-4.369c0-1.742-0.615-3.024-1.881-3.92c-1.329-0.941-3.246-1.419-5.698-1.419c-4.252,0-9.173,1.366-14.624,4.061c-0.739,0.366-1.639,0.064-2.008-0.676l-4.316-8.67c-0.36-0.725-0.082-1.604,0.63-1.988c6.689-3.614,13.864-5.447,21.325-5.447c6.421,0,11.613,1.578,15.434,4.69c3.864,3.15,5.825,7.402,5.825,12.639C70.82,34.697,70.014,37.749,68.424,40.295z" />
                                    </svg>
                                </div>
                            ` : ``}
                        </div>
                    </div>
                    <div class="author-info__bottom">
                        <div class="author-info__skills">
                            <p class="p author-info__subjects">${category_text}</p>
                            <p class="p author-info__types">${type_text}</p>
                        </div>
                        ${hireElement}
                    </div>
                </div>
            </div>
            <div class="author-statistics" id="stat-${user_id}">
                <p class="p author-statistics__title">Project statistics</p>
                <ul class="ul author-statistics__items">
                    ${statisticItems}
                </ul>
                <div class="author-statistics__bottom">
                    <span><a class="a" href="${profileUrl}" target="_blank">View expert's profile</a></span>
                    <button type="button" class="author-statistics__hide naked-button" data-js="hide-stat"><span class="dashed-text">hide</span></button>
                </div>
            </div>`
    }

    const renderAuthor = (author) => {
        const authorElement = document.createElement('li')
        authorElement.className = 'author'
        authorElement.setAttribute('data-author-id', author.user_id)
        authorElement.setAttribute('data-is-novice', author.isNoviceRating)
        authorElement.innerHTML = authorCardTemplate(author)
        authorsList.append(authorElement)

        if (parseFloat(author.grade) >= 0) setRating(authorElement, author.grade)
        setAuthorCardListeners(authorElement)
    }

    const hideAllSubjects = () => {
        subjectOptions.forEach((option) => option.hidden = true)
    }

    const revealSubjects = (areaId) => {
        subjectOptions.forEach((option) => option.hidden = option.dataset.subjectCategory !== areaId)
    }

    const handleCategoriesFilters = () => {

        subjectAreaSelect.addEventListener('change', (e) => {
            const selected = Number(e.target.value)
            subjectSelect.value = ""

            setLoadPage(0)
            setSubjectArea(selected)
            setSubject(0)

            loadAuthorsAndProcess(loadTriggers.subjectSelect).then(() => {
                if (selected === 0) return hideAllSubjects()

                const selectedAreaOption = subjectAreaSelect.options[subjectAreaSelect.selectedIndex]

                if (
                    subjectAreaSelect.value === "" ||
                    selectedAreaOption.dataset.noSubjectsPresent
                ) return subjectSelect.disabled = true

                const areaId = subjectAreaSelect.value
                revealSubjects(areaId)
            })
        })

        subjectSelect.addEventListener('change', (e) => {
            const selected = e.target.value
            selectedSubjectId = selected === "0" ? null : selected
            subjectAreaSelect.disabled = true
            subjectSelect.disabled = true

            setSubject(selected)
            setLoadPage(0)
            loadAuthorsAndProcess(loadTriggers.subjectSelect)
        })
    }

    const handleSearch = () => {
        searchForm.value = fetchAuthorsOptions.nick_name || ''
        searchForm.addEventListener('submit', e => {
            e.preventDefault()
            const value = e.target.elements['search-author'].value.trim()

            setLoadPage(0)
            setNickname(value)
            loadAuthorsAndProcess(loadTriggers.searchForm)
        })
    }

    const handleOnlineCheckbox = () => {
        onlineOnlyCheckbox.checked = fetchAuthorsOptions.online_only
        onlineOnlyCheckbox.addEventListener('change', e => {
            setOnline(e.target.checked)
            setLoadPage(0)
            loadAuthorsAndProcess(loadTriggers.onlineCheckbox)
        })
    }

    const handleFastreg = () => {
        const setError = error => fastregError.innerHTML = error
        const isErrorSet = () => Boolean(fastregError.innerHTML)
        const resetError = () => isErrorSet() && (fastregError.innerHTML = '')

        fastregCancelElements.forEach(element => {
            element.addEventListener('click', () => {
                fastRegModal.hidden = true
                document.body.style = {}
            })
        })
        fastregEmailInput.addEventListener('change', resetError)

        fastregForm.addEventListener('submit', (e) => {
            e.preventDefault()

            const email = fastregEmailInput.value
            const isEmailValid = /\S+@\S+\.\S+/.test(email)
            if (!isEmailValid) return setError('Invalid email')

            const body = new FormData()
            body.append('email', email)
            setLoadTriggerDisabled(fastregSubmit, true, loadTriggers.submitFastreg)

            fetch('/ajax/checkEmail', {
                method: 'POST',
                body,
                headers: {'x-requested-with': 'XMLHttpRequest'},
            })
                .then(res => res.json())
                .then(data => {
                    if (Number(data.count) === 0) return e.target.submit()
                    setError('This email is already registered')
                })
                .catch(error => console.warn(`Couldn't verify email. Error: ${error}`))
                .finally(() => setLoadTriggerDisabled(fastregSubmit, false))
        })
    }

    const fetchAuthors = () => {
        const url = new URL(`${window.location.origin}/authors/ajaxgetauthorsbyparams/`)

        for (let key in fetchAuthorsOptions) url.searchParams.set(key, fetchAuthorsOptions[key])

        return fetch(url)
            .then(res => res.json())
            .then(data => data.body)
            .catch((error) => console.warn(`Couldn't fetch authors. Error: ${error}`))
    }

    const renderAuthors = authors => authors.forEach(renderAuthor)

    const processLoadedAuthorsData = (data) => {
        resetAuthorsList()
        renderAuthors(data.authors)
        renderPagination(data.pagination)
        renderMeta({
            next: data.nexthref,
            prev: data.prevhref,
            canonical: data.canonical,
            description: data.description,
            keywords: data.keywords,
            headerText: data.headerText,
            title: data.title
        })
    }

    const scrollAuthorsIntoView = () => {
        const listRectTop = authorsList.getBoundingClientRect().top
        const bodyTop = document.body.getBoundingClientRect().top

        window.scroll({
            top: listRectTop - bodyTop - 16,
            behavior: "smooth"
        })
    }

    const loadAuthorsAndProcess = (trigger) => {

        if (trigger === loadTriggers.pagination) scrollAuthorsIntoView()

        setLoadingAuthors(true, trigger)
        return fetchAuthors()
            .then(processLoadedAuthorsData)
            .catch((error) => console.warn(`Couldn't load authors. Error: ${error}`))
            .finally(() => setLoadingAuthors(false))
    }

    const setPaginationListeners = () => {
        const links = paginationBlock.querySelectorAll('a')
        links.forEach(link => link.addEventListener('click', (e) => {
            e.preventDefault()
            const href = link.getAttribute('href')
            const match = href.match( /p(\d+)/)
            const page = match ? Number(match[1]) : 0

            window.history.pushState({page: Number(page)}, '', page ? `/authors/p${page}` : '/authors')
            setLoadPage(page)
            loadAuthorsAndProcess(loadTriggers.pagination)
        }))
    }

    const renderPagination = (pagination) => {
        paginationBlock.innerHTML = pagination
        if (!pagination) return

        setPaginationListeners()
    }

    const renderMeta = (meta) => {
        const next = meta.next
        const prev = meta.prev
        const canonical = meta.canonical
        const title = meta.title
        const desc = meta.description
        const headerText = meta.headerText
        const keywords = meta.keywords

        let nextElement = document.querySelector('link[rel="next"]')
        let prevElement = document.querySelector('link[rel="prev"]')
        let canonicalElement = document.querySelector('link[rel="canonical"]')
        let titleElement = document.head.querySelector('title')
        let descElement = document.head.querySelector('meta[name="description"]')
        let descOGElement = document.head.querySelector('meta[property="og:description"]')
        let titleOGElement = document.head.querySelector('meta[property="og:title"]')
        let keywordsElement = document.head.querySelector('meta[name="keywords"]')

        if (next) setMeta({
            element: nextElement,
            tag: 'link',
            attrs: { rel: 'next', href: next },
        }); else removeMeta(nextElement)

        if (prev) setMeta({
            element: prevElement,
            tag: 'link',
            attrs: { rel: 'prev', href: prev },
        }); else removeMeta(prevElement)

        if (canonical) setMeta({
            element: canonicalElement,
            tag: 'link',
            attrs: { rel: 'canonical', href: canonical },
        }); else removeMeta(canonicalElement)

        if (keywords) setMeta({
            element: keywordsElement,
            tag: 'meta',
            attrs: { name: 'keywords', content: keywords },
        })

        if (desc) {
            setMeta({
                element: descElement,
                tag: 'meta',
                attrs: { name: 'description', content: desc },
            })
            setMeta({
                element: descOGElement,
                tag: 'meta',
                attrs: { property: 'og:description', content: desc },
            })
        } else {
            removeMeta(descElement)
            removeMeta(descOGElement)
        }

        if (title) {
            setMeta({
                element: titleElement,
                content: title,
            })
            setMeta({
                element: titleOGElement,
                tag: 'meta',
                attrs: { property: 'og:title', content: title },
            })
        } else removeMeta(titleOGElement)

        if (headerText) header.innerHTML = headerText
    }

    const initRouting = () => {
        window.history.scrollRestoration = 'manual'
        window.addEventListener('popstate', (e) => {
            const state = e.state
            if (typeof state !== 'object') return

            const page = state === null ? 0 : Number(state.page)
            if (isNaN(page)) return

            setLoadPage(page)
            loadAuthorsAndProcess(loadTriggers.pagination)
        })
    }

    function main() {
        initRouting()
        handleCategoriesFilters()
        setPaginationListeners()
        initAuthorsCards()
        handleSearch()
        handleOnlineCheckbox()
        handleFastreg()
    }

    main()
}

handler()
header()
revealLinksOnAction(handleRefsUs.bind(null, REFS_US.SEO_US_AUTHORS))